import React from 'react';
import Icon, { IconProps } from './Icon';

const CartIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor', ...props }) => {
  return (
    <Icon size={size} color={color} viewBox="0 0 24 24" {...props}>
      <path
        d="M16.0001 9.00012V6.00012C16.0001 3.79098 14.2093 2.00012 12.0001 2.00012C9.79099 2.00012 8.00013 3.79098 8.00013 6.00012V9.00012M3.59213 10.3521L2.99213 16.7521C2.82153 18.5718 2.73623 19.4816 3.03818 20.1844C3.30342 20.8018 3.76824 21.3122 4.35814 21.6339C5.02965 22.0001 5.94349 22.0001 7.77117 22.0001H16.2291C18.0568 22.0001 18.9706 22.0001 19.6421 21.6339C20.232 21.3122 20.6968 20.8018 20.9621 20.1844C21.264 19.4816 21.1787 18.5718 21.0081 16.7521L20.4081 10.3521C20.2641 8.81547 20.192 8.04716 19.8465 7.46629C19.5421 6.95471 19.0925 6.54523 18.5547 6.28997C17.9441 6.00012 17.1724 6.00012 15.6291 6.00012L8.37117 6.00012C6.82782 6.00012 6.05614 6.00012 5.44554 6.28997C4.90779 6.54523 4.45813 6.95471 4.15379 7.46628C3.80822 8.04716 3.73619 8.81547 3.59213 10.3521Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Icon>
  );
};

export default CartIcon;

